import './MissingResource.css'
import { Button, Card } from '../index'

export function MissingResource({
  title,
  description,
  callToAction,
  onClick
}: {
  title?: string
  description?: React.ReactNode
  callToAction?: string
  onClick?: () => void
}) {
  return (
    <Card>
      <div className="missing-resource-content">
        <p className="missing-resource-title">{title}</p>
        <p className="missing-resource-description">{description}</p>
      </div>
      {callToAction && (
        <div className="missing-resource-action">
          <Button sizeType="sm" className="missing-resource-button" onClick={onClick}>
            {callToAction}
          </Button>
        </div>
      )}
    </Card>
  )
}
